import React from 'react'

function EditProfileDetails() {
  return (
    <div className='Edit-profile-details-page'>
      <h1>Edit profile details</h1>
    </div>
  )
}

export default EditProfileDetails
